<template>
  <div class="sme-digital-page">
    <!-- 导航栏 -->
    <UnifiedNavBar />

    <!-- 英雄区域 -->
    <section class="hero-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-8 mx-auto text-center">
            <div class="hero-content">
              <h1 class="display-3 fw-bold mb-4">智邦国际ERP系统</h1>
              <p class="lead mb-4 fs-4">专为中小企业打造的一体化数字化转型解决方案</p>
              <p class="mb-5 fs-5">集成销售、采购、库存、生产、财务、人力资源等核心业务模块，涵盖CRM、SCM、OA、BI等扩展功能，支持移动办公、云端部署，助力企业实现管理数字化、流程标准化、决策智能化</p>
              <div class="d-flex flex-wrap gap-3 justify-content-center">
                <a href="#core-modules" class="btn btn-primary btn-lg px-4 py-3">
                  <i class="fas fa-cogs me-2"></i>核心功能
                </a>
                <a href="#product-series" class="btn btn-outline-light btn-lg px-4 py-3">
                  <i class="fas fa-layer-group me-2"></i>产品系列
                </a>
                <a href="#contact" class="btn btn-outline-light btn-lg px-4 py-3">
                  <i class="fas fa-phone me-2"></i>免费试用
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 行业痛点分析 -->
    <section id="pain-points" class="py-5">
      <div class="container">
        <h2 class="section-title">中小企业面临的8大核心痛点</h2>
        <div class="row">
          <div v-for="(painPoint, index) in painPoints" :key="index" class="col-lg-3 col-md-6 mb-4">
            <div class="pain-point-card">
              <div class="pain-icon">
                <i :class="painPoint.icon"></i>
              </div>
              <h5>{{ painPoint.title }}</h5>
              <p class="text-muted">{{ painPoint.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 解决方案 -->
    <section id="solutions" class="py-5 bg-light">
      <div class="container">
        <h2 class="section-title">智邦ERP一体化解决方案</h2>
        <div class="row">
          <div v-for="(solution, index) in solutions" :key="index" class="col-lg-4 col-md-6 mb-4">
            <div class="solution-card text-center">
              <div class="solution-icon">
                <i :class="solution.icon"></i>
              </div>
              <h4>{{ solution.title }}</h4>
              <p class="text-muted mb-4">{{ solution.description }}</p>
              <ul class="list-unstyled text-start">
                <li v-for="(feature, idx) in solution.features" :key="idx">
                  <i class="fas fa-check text-success me-2"></i>{{ feature }}
                </li>
              </ul>
              <button class="btn btn-primary mt-3">立即体验</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心管理模块 -->
    <section id="core-modules" class="py-5">
      <div class="container">
        <h2 class="section-title">六大核心管理模块</h2>
        <div class="row">
          <div v-for="(module, index) in coreModules" :key="index" class="col-lg-4 col-md-6 mb-4">
            <div class="solution-card">
              <div class="solution-icon">
                <i :class="module.icon"></i>
              </div>
              <h4 class="text-center">{{ module.title }}</h4>
              <p class="text-muted text-center mb-3">{{ module.description }}</p>
              <ul class="list-unstyled">
                <li v-for="(feature, idx) in module.features" :key="idx">
                  <i class="fas fa-check text-success me-2"></i>{{ feature }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 扩展功能模块 -->
    <section id="extended-modules" class="py-5 bg-light">
      <div class="container">
        <h2 class="section-title">十大扩展功能模块</h2>
        <div class="row">
          <div v-for="(module, index) in extendedModules" :key="index" class="col-lg-4 col-md-6 mb-4">
            <div class="solution-card">
              <div class="solution-icon">
                <i :class="module.icon"></i>
              </div>
              <h4 class="text-center">{{ module.title }}</h4>
              <p class="text-muted text-center mb-3">{{ module.description }}</p>
              <ul class="list-unstyled">
                <li v-for="(feature, idx) in module.features" :key="idx">
                  <i class="fas fa-check text-success me-2"></i>{{ feature }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品系列介绍 -->
    <section id="product-series" class="section-padding">
      <div class="container">
        <h2 class="section-title">智邦国际ERP产品系列</h2>
        <p class="text-center text-muted mb-5">覆盖不同规模企业需求，提供全方位数字化解决方案</p>
        
        <!-- 经典型产品 -->
        <div class="product-series-section mb-5">
          <h3 class="series-title"><i class="fas fa-star text-warning me-2"></i>一体化ERP（经典型）</h3>
          <p class="series-desc">适合成熟企业的全功能ERP解决方案</p>
          <div class="row">
            <div v-for="(product, index) in classicProducts" :key="index" class="col-lg-2 col-md-4 col-sm-6 mb-3">
              <div class="product-item">
                <div class="product-icon">
                  <i :class="product.icon"></i>
                </div>
                <h6>{{ product.name }}</h6>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 行业型产品 -->
        <div class="product-series-section mb-5">
          <h3 class="series-title"><i class="fas fa-cogs text-primary me-2"></i>一体化ERP（行业型）</h3>
          <p class="series-desc">针对特定行业深度定制的专业解决方案</p>
          <div class="row">
            <div v-for="(product, index) in industryProducts" :key="index" class="col-lg-2 col-md-4 col-sm-6 mb-3">
              <div class="product-item">
                <div class="product-icon">
                  <i :class="product.icon"></i>
                </div>
                <h6>{{ product.name }}</h6>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 简易型产品 -->
        <div class="product-series-section mb-5">
          <h3 class="series-title"><i class="fas fa-rocket text-success me-2"></i>一体化ERP（简易型）</h3>
          <p class="series-desc">适合小微企业快速上手的轻量级解决方案，简单易用，快速部署</p>
          <div class="row">
            <div v-for="(product, index) in simpleProducts" :key="index" class="col-lg-4 col-md-6 mb-4">
              <div class="product-item">
                <div class="product-icon">
                  <i :class="product.icon"></i>
                </div>
                <h6>{{ product.name }}</h6>
                <p class="text-muted mt-2 mb-3">{{ product.description }}</p>
                <div class="product-features">
                  <span v-for="(feature, idx) in product.features" :key="idx" class="badge bg-success me-1 mb-1">{{ feature }}</span>
                </div>
                <div class="mt-3">
                  <small class="text-primary"><i class="fas fa-users me-1"></i>{{ product.teamSize }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 云应用产品 -->
        <div class="product-series-section mb-5">
          <h3 class="series-title"><i class="fas fa-cloud text-info me-2"></i>一体化ERP（云应用）</h3>
          <p class="series-desc">基于云计算的现代化ERP解决方案，随时随地办公，数据安全可靠</p>
          <div class="row">
            <div v-for="(product, index) in cloudProducts" :key="index" class="col-lg-4 col-md-6 mb-4">
              <div class="product-item">
                <div class="product-icon">
                  <i :class="product.icon"></i>
                </div>
                <h6>{{ product.name }}</h6>
                <p class="text-muted mt-2 mb-3">{{ product.description }}</p>
                <div class="product-features">
                  <span v-for="(feature, idx) in product.features" :key="idx" class="badge bg-info me-1 mb-1">{{ feature }}</span>
                </div>
                <div class="mt-3">
                  <small class="text-info"><i class="fas fa-users me-1"></i>{{ product.teamSize }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer组件 -->
    <Footer />
  </div>
</template>

<script>
import UnifiedNavBar from '@/components/UnifiedNavBar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'SmeDigital',
  components: {
    UnifiedNavBar,
    Footer
  },
  data() {
    return {
      painPoints: [
        {
          icon: 'fas fa-boxes',
          title: '产品种类繁多',
          description: '产品规格复杂，型号众多，管理困难，容易出现库存积压或缺货问题。'
        },
        {
          icon: 'fas fa-user-clock',
          title: '客户需求变化频繁',
          description: '客户需求变化快，订单调整频繁，传统管理方式难以快速响应。'
        },
        {
          icon: 'fas fa-list-alt',
          title: '物料清单管理复杂',
          description: 'BOM管理混乱，物料需求计算不准确，影响生产计划和成本控制。'
        },
        {
          icon: 'fas fa-calendar-times',
          title: '生产计划不准确',
          description: '生产计划制定困难，资源配置不合理，导致交期延误和成本上升。'
        },
        {
          icon: 'fas fa-search-minus',
          title: '生产进度难掌控',
          description: '生产进度不透明，无法实时了解订单执行情况，影响客户满意度。'
        },
        {
          icon: 'fas fa-truck-loading',
          title: '生产交付管理混乱',
          description: '交付流程不规范，发货管理混乱，客户投诉频发。'
        },
        {
          icon: 'fas fa-shield-alt',
          title: '质量追溯困难',
          description: '质量问题难以追溯，缺乏完整的质量管理体系，影响产品品质。'
        },
        {
          icon: 'fas fa-calculator',
          title: '成本核算不精确',
          description: '成本核算方式粗放，无法精确计算产品成本，影响定价决策。'
        }
      ],
      solutions: [
        {
          icon: 'fas fa-chart-line',
          title: 'ERP经典版',
          description: '适合在一套系统里管理公司全部业务的企业使用，涵盖销售、采购、库存、财务等全流程管理。',
          features: ['全业务流程管理', '多部门协同办公', '数据统一管理', '权限精细控制', '报表自动生成']
        },
        {
          icon: 'fas fa-cogs',
          title: 'ERP生产版',
          description: '专为生产制造企业设计，强化生产管理功能，实现从订单到交付的全程管控。',
          features: ['生产计划管理', '生产进度追踪', '物料清单管理', '质量控制追溯', '成本核算分析']
        },
        {
          icon: 'fab fa-weixin',
          title: 'ERP微信版',
          description: '基于微信生态的移动ERP解决方案，随时随地处理业务，提升工作效率。',
          features: ['微信商城集成', '移动端管理', '社交化办公', '即时消息通知', '二维码应用']
        }
      ],
      coreModules: [
        {
          icon: 'fas fa-chart-line',
          title: '销售管理',
          description: '全流程销售管理，从线索到回款的完整闭环',
          features: ['销售计划制定与执行跟踪', '销售订单管理与审批流程', '销售出库与发货管理', '销售结算与回款管理', '客户信息与关系维护', '销售业绩统计与分析']
        },
        {
          icon: 'fas fa-shopping-cart',
          title: '采购管理',
          description: '智能采购管理，降低成本提升效率',
          features: ['采购计划制定与需求分析', '采购订单管理与审批', '采购入库与质检管理', '采购结算与付款管理', '供应商评估与管理', '采购成本分析与控制']
        },
        {
          icon: 'fas fa-warehouse',
          title: '库存管理',
          description: '精准库存控制，优化资金占用',
          features: ['库存盘点与差异处理', '库存调拨与转移管理', '库存报废与损耗管理', '物料需求计划（MRP）', '安全库存与预警机制', '库存周转率分析']
        },
        {
          icon: 'fas fa-cogs',
          title: '生产管理',
          description: '精益生产管理，提升生产效率',
          features: ['生产计划制定与排程', '生产订单下达与跟踪', '生产入库与质量管控', '生产成本核算与分析', '工艺路线与BOM管理', '设备产能与效率分析']
        },
        {
          icon: 'fas fa-calculator',
          title: '财务管理',
          description: '全面财务管控，实时掌握经营状况',
          features: ['总账管理与会计核算', '应收应付款管理', '成本核算与分析', '资金管理与现金流', '财务报表自动生成', '预算管理与费用控制']
        },
        {
          icon: 'fas fa-users',
          title: '人力资源',
          description: '全员人力资源管理，激发团队潜能',
          features: ['员工档案与组织架构', '考勤管理与请假审批', '薪资核算与发放管理', '绩效考核与评估', '培训管理与技能提升', '人力成本分析与优化']
        }
      ],
      extendedModules: [
        {
          icon: 'fas fa-handshake',
          title: '客户关系管理（CRM）',
          description: '全方位客户关系管理，提升客户满意度',
          features: ['客户信息管理', '销售机会跟踪', '客户服务与投诉处理', '营销活动管理']
        },
        {
          icon: 'fas fa-project-diagram',
          title: '项目管理（PM）',
          description: '专业项目管理，确保项目按时交付',
          features: ['项目计划与进度管理', '任务分配与跟踪', '项目成本控制', '项目文档管理']
        },
        {
          icon: 'fas fa-link',
          title: '供应链管理（SCM）',
          description: '端到端供应链优化，降低运营成本',
          features: ['供应链计划与协调', '物流配送管理', '供应商协同', '供应链风险管控']
        },
        {
          icon: 'fas fa-truck',
          title: '供应商关系管理（SRM）',
          description: '供应商全生命周期管理',
          features: ['供应商准入与认证', '供应商绩效评估', '供应商协同平台', '供应商风险管理']
        },
        {
          icon: 'fas fa-tools',
          title: '企业资产管理（EAM）',
          description: '设备资产全生命周期管理',
          features: ['固定资产管理', '设备维护保养', '备件库存管理', '资产折旧计算']
        },
        {
          icon: 'fas fa-brain',
          title: '知识管理（KM）',
          description: '企业知识资产管理与共享',
          features: ['知识库建设与维护', '文档版本控制', '知识搜索与推荐', '专家知识管理']
        },
        {
          icon: 'fas fa-file-alt',
          title: '办公自动化（OA）',
          description: '高效协同办公，提升组织效率',
          features: ['工作流程审批', '公文管理', '会议管理', '通知公告']
        },
        {
          icon: 'fas fa-chart-bar',
          title: '商业智能（BI）',
          description: '数据驱动决策，洞察商业价值',
          features: ['多维数据分析', '可视化报表', '经营仪表盘', '预测分析']
        },
        {
          icon: 'fas fa-mobile-alt',
          title: '移动办公应用',
          description: '随时随地移动办公，提升工作效率',
          features: ['移动审批', '移动查询', '移动报表', '消息推送']
        }
      ],
      classicProducts: [
        { icon: 'fas fa-industry', name: '制造业ERP' },
        { icon: 'fas fa-store', name: '贸易ERP' },
        { icon: 'fas fa-shopping-cart', name: '零售ERP' },
        { icon: 'fas fa-concierge-bell', name: '服务ERP' },
        { icon: 'fas fa-building', name: '集团ERP' }
      ],
      industryProducts: [
        { icon: 'fas fa-hammer', name: '机械制造' },
        { icon: 'fas fa-microchip', name: '电子电器' },
        { icon: 'fas fa-tshirt', name: '服装鞋帽' },
        { icon: 'fas fa-utensils', name: '食品饮料' },
        { icon: 'fas fa-pills', name: '医药化工' },
        { icon: 'fas fa-home', name: '家居建材' }
      ],
      simpleProducts: [
        {
          icon: 'fas fa-seedling',
          name: '创业版ERP',
          description: '初创企业首选，基础功能齐全',
          features: ['销售管理', '库存管理', '财务管理'],
          teamSize: '适合1-10人团队'
        },
        {
          icon: 'fas fa-chart-line',
          name: '成长版ERP',
          description: '成长期企业理想选择，功能更全面',
          features: ['生产管理', '采购管理', 'CRM系统'],
          teamSize: '适合10-50人团队'
        },
        {
          icon: 'fas fa-trophy',
          name: '专业版ERP',
          description: '专业企业首选，功能强大完整',
          features: ['全模块集成', '高级分析', '定制开发'],
          teamSize: '适合50+人团队'
        }
      ],
      cloudProducts: [
        {
          icon: 'fas fa-cloud-upload-alt',
          name: '云ERP基础版',
          description: '小微企业云端首选，功能精简实用',
          features: ['基础模块', '云端存储', '移动访问'],
          teamSize: '适合1-20人团队'
        },
        {
          icon: 'fas fa-server',
          name: '云ERP专业版',
          description: '中型企业理想选择，功能全面强大',
          features: ['全功能模块', '高级分析', 'API集成'],
          teamSize: '适合20-200人团队'
        },
        {
          icon: 'fas fa-globe',
          name: '云ERP集团版',
          description: '大型集团企业专属，多组织架构支持',
          features: ['集团管控', '多组织架构', '高级定制'],
          teamSize: '适合200+人团队'
        }
      ]
    }
  }
}
</script>

<style scoped>
:root {
  --primary-blue: #1e40af;
  --light-blue: #3b82f6;
  --dark-blue: #1e3a8a;
  --accent-blue: #60a5fa;
  --gradient-bg: linear-gradient(135deg, #1e40af, #3b82f6);
}

.hero-section {
  background: var(--gradient-bg);
  color: white;
  padding: 120px 0 80px;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" fill="%23ffffff" opacity="0.1"><polygon points="1000,100 1000,0 0,100"/></svg>');
  background-size: cover;
}

.hero-section::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 30% 50%, rgba(255,255,255,0.1) 0%, transparent 50%);
}

.hero-content {
  position: relative;
  z-index: 2;
}

.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: var(--primary-blue);
  text-align: center;
  margin-bottom: 4rem;
  position: relative;
  padding-bottom: 1rem;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 4px;
  background: linear-gradient(90deg, var(--light-blue), var(--accent-blue));
  border-radius: 2px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.pain-point-card {
  background: white;
  border-radius: 20px;
  padding: 2.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 15px 35px rgba(0,0,0,0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(30, 64, 175, 0.1);
  position: relative;
  overflow: hidden;
  height: 100%;
}

.pain-point-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, var(--light-blue), var(--accent-blue));
}

.pain-point-card:hover {
  transform: translateY(-15px) scale(1.02);
  box-shadow: 0 25px 50px rgba(30, 64, 175, 0.15);
  border-color: var(--light-blue);
}

.pain-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #ef4444, #f97316);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  color: white;
}

.solution-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  margin-bottom: 2rem;
  box-shadow: 0 15px 35px rgba(0,0,0,0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(30, 64, 175, 0.1);
  position: relative;
  overflow: hidden;
  height: 100%;
}

.solution-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, var(--light-blue), var(--accent-blue));
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.solution-card:hover::before {
  transform: scaleX(1);
}

.solution-card:hover {
  transform: translateY(-15px) scale(1.02);
  box-shadow: 0 25px 50px rgba(30, 64, 175, 0.15);
  border-color: var(--light-blue);
}

.solution-icon {
  width: 80px;
  height: 80px;
  background: var(--gradient-bg);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2rem;
  color: white;
}

.product-series-section {
  margin-bottom: 4rem;
}

.series-title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.series-desc {
  text-align: center;
  color: #6b7280;
  font-size: 1.1rem;
  margin-bottom: 3rem;
}

.product-item {
  background: white;
  border-radius: 20px;
  padding: 2.5rem 1.5rem;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  height: 100%;
  min-height: 200px;
}

.product-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--light-blue), var(--accent-blue));
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.product-item:hover::before {
  transform: scaleX(1);
}

.product-item:hover {
  transform: translateY(-12px) scale(1.03);
  box-shadow: 0 20px 40px rgba(30, 64, 175, 0.15);
  border-color: var(--light-blue);
}

.product-item .product-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, var(--primary-blue), var(--light-blue));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 1.8rem;
  color: white;
  transition: all 0.3s ease;
}

.product-item:hover .product-icon {
  transform: scale(1.1) rotate(5deg);
  background: linear-gradient(135deg, var(--light-blue), var(--accent-blue));
}

.product-item h6 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--primary-blue);
  margin-bottom: 0;
  transition: color 0.3s ease;
}

.product-item:hover h6 {
  color: var(--light-blue);
}



.btn-primary {
  background: var(--gradient-bg);
  border: none;
  padding: 12px 30px;
  border-radius: 25px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

.btn-outline-light {
  border: 2px solid white;
  color: white;
  padding: 10px 25px;
  border-radius: 25px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-outline-light:hover {
  background: white;
  color: var(--primary-blue);
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-section {
    padding: 100px 0 60px;
    min-height: 80vh;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .pain-point-card,
  .solution-card {
    padding: 2rem;
    margin-bottom: 1.5rem;
  }
}

@media (max-width: 576px) {
  .section-title {
    font-size: 1.8rem;
  }
  
  .pain-point-card,
  .solution-card {
    padding: 1.5rem;
  }
  
  .hero-section {
    padding: 80px 0 40px;
  }
}
</style>